const SupportingAssociation = () => {
    return (
        <div>
            <h1>Soutenir une association</h1>
        </div>
    );
};

export default SupportingAssociation;
